module.exports = __webpack_public_path__ + "img/logo.b966705c.svg";